import { render } from "./MediaWidget.vue?vue&type=template&id=1086daca&scoped=true"
import script from "./MediaWidget.vue?vue&type=script&lang=js"
export * from "./MediaWidget.vue?vue&type=script&lang=js"

import "./MediaWidget.vue?vue&type=style&index=0&id=1086daca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1086daca"]])

export default __exports__